var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrap-progress"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:(_vm.setProgressStyle),attrs:{"role":"progressbar","aria-valuenow":50,"aria-valuemin":"0","aria-valuemax":"100"}})]),_c('div',{staticClass:"progress-title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }